import { publicGet } from '../../../api';
import { endpoints } from '../../../api/domains/endpoints';

export function getWhatshotPublishersAPI({ token, traceId }) {
    return publicGet(endpoints().whatsHot, { token, traceId });
}

export function getDiscoverPublishersAPI({ token, traceId }) {
    return publicGet(endpoints().discoverPublishers, { token, traceId });
}
